import { render, staticRenderFns } from "./Proveedores.vue?vue&type=template&id=358d7fdc&scoped=true&"
import script from "./Proveedores.vue?vue&type=script&lang=js&"
export * from "./Proveedores.vue?vue&type=script&lang=js&"
import style0 from "./Proveedores.vue?vue&type=style&index=0&id=358d7fdc&prod&lang=scss&scoped=true&"
import style1 from "./Proveedores.vue?vue&type=style&index=1&id=358d7fdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358d7fdc",
  null
  
)

export default component.exports